import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { commonMessages } from 'ne01-common/src/i18n';

Vue.use(VueI18n);

const messages = {
  'de': {
    quiz: {
      next: 'Weiter',
      levelOverview: 'Konzert {a} von {b}',
      optionOverview: '{a} von {b} Vogelarten',
      exitStation: 'Station abschliessen',
      expertModeButton: 'Bonuskonzert für Profis',
      expertStatus: 'Bonuskonzert',
    },
    end: {
      label1: 'Vogelarten richtig erkannt,',
      label2: 'falsch bestimmt.',
      unload: 'Neue Station laden',
    },
    ... commonMessages.de
  },
  'fr': {
    quiz: {
      next: 'Continuer',
      levelOverview: 'Concert {a} sur {b}',
      optionOverview: '{a} sur {b} espèces d\'oiseaux',
      exitStation: 'Terminer la station',
      expertModeButton: 'Concert bonus pour les experts',
      expertStatus: 'Concert bonus',
    },
    end: {
      label1: 'espèces d\'oiseaux correctement identifiées,',
      label2: 'pas identifiées correctement.',
      unload: 'Charger une nouvelle station',
    },
    ... commonMessages.fr
  }
};

const i18n = new VueI18n({
  locale: 'de',
  messages,
});

export default i18n;